var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderLock = function SvgIconFolderLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5v10h5.806a1 1 0 0 1 0 2H3.694A1.694 1.694 0 0 1 2 18.806V4.875a1.75 1.75 0 0 1 1.75-1.75h4.912a1.75 1.75 0 0 1 1.311.59h.001L12.45 6.5h7.801A1.75 1.75 0 0 1 22 8.25v.375a1 1 0 1 1-2 0V8.5zm4.476-3.46v.002zm.075.085L9.773 6.5H4V5.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.375v-.5a2.875 2.875 0 1 0-5.75 0v.5h-.5a1 1 0 0 0-1 1V19.5a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1v-4.125a1 1 0 0 0-1-1zM17.625 13a.875.875 0 0 0-.875.875v.5h1.75v-.5a.875.875 0 0 0-.875-.875m-2.375 3.375V18.5H20v-2.125z"
  }))));
};
export default SvgIconFolderLock;